import React from 'react';

function renderFormFields(data) {
	let formFields = [
		{}
	];
	if (data && data.length) {
		formFields = data.map((field, idx) => (
			<span key={idx} className="m-2 d-inline-block">
				<label htmlFor={field.name} />
				<input className="p-2" type={field.type} placeholder={field.name} />
			</span>
		));
	}
	return formFields;
}

export default function RegistrationForm(props) {
	// console.log('RegistrationForm', props);
	return (
		<div className="RegistrationForm">
			<div className="mx-5">{renderFormFields(props.data)}</div>
		</div>
	);
}
